import { useRouter } from "vue-router";
import { defineComponent, onMounted, ref } from "vue";
import GoodLeft from "./GoodLeft.vue";
import GoodRight from "./GoodRight.vue";
const INIT_HEIGHT = 200;
const MAX_TOP_SCROLL = 150;
export default defineComponent({
  props: ["goods"],
  components: {
    // eslint-disable-next-line vue/no-unused-components
    GoodLeft,
    // eslint-disable-next-line vue/no-unused-components
    GoodRight
  },

  setup(props) {
    const router = useRouter();
    let containerDom = null;
    let contentElement = null;
    const headerHeightAndContentTop = ref(INIT_HEIGHT);

    const bindContainertDom = el => containerDom = el;

    const bindContentDom = el => contentElement = el;

    const scroll = function () {
      var _containerDom;

      const top = ((_containerDom = containerDom) === null || _containerDom === void 0 ? void 0 : _containerDom.scrollTop) || 0; // const mintop =
      //   INIT_HEIGHT - (top > MAX_TOP_SCROLL ? MAX_TOP_SCROLL : top);
      // headerHeightAndContentTop.value = mintop;

      if (top > MAX_TOP_SCROLL && contentElement) {
        contentElement.style.position = "absolute";
        contentElement.style.top = INIT_HEIGHT - MAX_TOP_SCROLL + "px"; // containerDom.style.overflow = "hidden";
      }
    };

    onMounted(() => {
      // contentElement && (contentElement.onscroll = scroll);
      containerDom && (containerDom.onscroll = scroll);
    });

    const toBack = () => {
      router.back();
    };

    return {
      toBack,
      good: props.goods,
      bindContentDom,
      bindContainertDom,
      headerHeightAndContentTop
    };
  }

});